import React, { useState } from 'react'
import styles from "./missingFincalist.module.css"
import IMAGES from '../../../assets/images/images'
import SecondaryTooltip from '../../../components/secondaryToolTip/secondaryToolTip'
import { Link, useNavigate } from 'react-router-dom';
import CAN from "../../../casl/can"
import { Action, Resource } from "../../../casl/constants";
import SectionGuard from "../../../hoc/guards/SectionGuard";

function MissingFincalist(props) {
    const [isShowMissingFincaCust, setIsShowMissingFincaCust] = useState(false);
    const navigate = useNavigate();

    const toggleMissingFincaCust=()=>{
        setIsShowMissingFincaCust(!isShowMissingFincaCust)
    }

    const handleCustomerClick = (customerId) => {
        navigate(`/user-management/customerdetail/${customerId}`);
    };
    let missingmessage = ``
    if(CAN(Action.UPDATE,Resource.CUSTOMERS)){
      missingmessage = <div className={styles.infomsg}>We have observed that the  Invoice code has not been added for the customers listed below, resulting in the inability to view or download their invoices. To rectify this, please click the <span className={styles.boldtext}>{`arrow (>)`}</span> icon and take the necessary action to add the Invoice code.</div>
    }else{
      missingmessage = <div className={styles.infomsg}>We have observed that the  Invoice code has not been added for the customers listed below, resulting in the inability to view or download their invoices.</div>
    }
    return (
        <div className={styles.missingfincacust}>
          <img className={styles.Vector} src={IMAGES.Vector} alt=""/><span className={styles.infotext}><span className={styles.missingcusttext}>Attention Needed:</span> Please click <span className={styles.clickhere} onClick={toggleMissingFincaCust}>here</span> to view the list of customers whose <span className={styles.boldtext}>Invoice code</span> is missing and has not yet been added to the portal. This action is necessary to view the monthly customer invoices. Failure to add the code will result in an inability to view the customer invoices generated so far.</span>
            {/* <div className={styles.missingcusttext}>
                <img className={styles.Vector} src={IMAGES.Vector} alt=""/>
                FinCA code not added for Customers 
                <SecondaryTooltip text={"Click to view pending customers"} positions={['bottom', 'right']} >
                    <img className={styles.missingfincainfo} src={IMAGES.infoCircle} onClick={toggleMissingFincaCust}/>
                </SecondaryTooltip> */}
            {/* </div> */}
            
            {isShowMissingFincaCust && ( 
                <div className={styles.alertmessage}>
                    <div className={styles.alertcontent}>
                        <div className={`${styles.header}`}> 
                          <div className={styles.headertext}>Invoice Code required for below customers</div>
                          <img className={styles.close} src={IMAGES.close} alt="Close" onClick={toggleMissingFincaCust}/> 
                        </div>
                        {missingmessage}
                        <div className={styles.tableparent}>
                        <div className={`${styles.tableContainer} table-responsive`}>
                          <table className={`table ${styles.customTable}`} style={{margin:0}}>
                            <thead className={styles.tableHeader}>
                              <tr>
                                <th className={styles.tableHeaderCell}><div className={styles.headerContent}>Organisation Legal Name</div></th>
                              </tr>
                            </thead>
                            <tbody className={styles.tabledata}>
                              {props?.missingFincaCustomers?.length===0?(<tr className={styles.nodata}>
                                 <td colSpan={1} className={styles.filterdata}>No Customers Found</td>
                              </tr>):
                              props?.missingFincaCustomers?.sort((a, b) => a?.displayName?.localeCompare(b?.displayName))?.map((item,rowIndex)=>{
                                // const customerId = encodeURIComponent(item.uniqueCustomerRefId);
                                return(
                                  <tr className={`${rowIndex % 2 === 0 ? styles.evenRow : styles.oddRow}`}>
                                   <td  className={`${styles.tableCell}`}>{item.displayName}
                                   {/* <Link className={styles.link} to={`/user-management?customerId=${customerId}`}> */}
                                   <SectionGuard canAccess={CAN(Action.UPDATE,Resource.CUSTOMERS)}>
                                    <Link to={`/user-management/customerdetail/${item.uniqueCustomerRefId}`}>
                                     <img className={styles.arrowdown} src={IMAGES.arrows} alt="arrow" 
                                    //  onClick={() => handleCustomerClick(item.uniqueCustomerRefId)}
                                     />
                                    </Link>
                                   </SectionGuard>
                                   {/* </Link> */}
                                   </td>
                                  </tr>
                                );
                                })}
                            </tbody>
                           </table>
                        </div>
                        </div>
                    </div> 
                </div>
            )}
        </div>
    )
}

export default MissingFincalist
